/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Process_Step_ClassificationInputs */

const en_input_process_step_classification = /** @type {(inputs: Input_Process_Step_ClassificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification`)
};

const nl_input_process_step_classification = /** @type {(inputs: Input_Process_Step_ClassificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificatie`)
};

/**
* | output |
* | --- |
* | "Classification" |
*
* @param {Input_Process_Step_ClassificationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const input_process_step_classification = /** @type {((inputs?: Input_Process_Step_ClassificationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Process_Step_ClassificationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_input_process_step_classification(inputs)
	return en_input_process_step_classification(inputs)
});